/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import {
    Button,
    Col,
    Modal,
    ModalBody, ModalFooter,
    ModalHeader,
    Row,
    Table,
} from "reactstrap";

import { usePagination } from "../../../../hooks";
import { adminGetDeviceEvents } from "../../../../actions/Devices/actions";
import { formatDateTime } from "../../Layers/fields/formatters";
import { useEDDateFormats } from "../../../../actions/Tenants/config/configHook";
import DeviceEventDump from "../../../Devices/DeviceEventDump";
import DeviceEventStatusBadge from "../../../Devices/DeviceEventStatusBadge";
import { Loading } from "../../../Helper/Loading";
import { PaginationRow } from "../../../Helper/PaginationRow";

const defaultEvent = { status: "", id: "" };
export default function DeviceEventHistory() {
    const eventHistory = useSelector((state) => state.devices.eventHistory);
    const isLoading = useSelector((state) => state.devices.isLoading);
    const device = useSelector((state) => state.devices.current);
    const dispatch = useDispatch();
    const params = useParams();
    // * EFQ-3850 — admin-only page; always render in ED format.
    const edFormats = useEDDateFormats();

    const isDataUnavailable = isLoading || !eventHistory || params.device_uid !== device?.UID;

    const { offset, limit } = usePagination();

    // TODO FIGURE THIS SPECIFIC CASE OUT
    useEffect(() => {
        dispatch(adminGetDeviceEvents(device.UID, { limit, offset }));
    }, [offset, limit]);

    useEffect(() => {
        const offset = 0;
        dispatch(adminGetDeviceEvents(params.device_uid, { limit, offset }));
    }, [limit, params.device_uid]);


    const [currentEvent, setCurrentEvent] = useState(defaultEvent);
    const closeModal = () => setCurrentEvent(defaultEvent);

    if (isDataUnavailable) {
        return <Loading />;
    }

    return (
        <div>
            <Row>
                <Col>
                    <div css={css`min-height: 30vh;`}>
                        <Table hover>
                            <thead>
                                <tr>
                                    <th>Event ID</th>
                                    <th>Command</th>
                                    <th>Status</th>
                                    <th>Created</th>
                                    <th>Updated</th>
                                    <th>Details</th>
                                </tr>
                            </thead>
                            <tbody>
                                {eventHistory.results.map((i) => <tr key={i.id}>
                                    <td>{i.id}</td>
                                    <td>{i.command}</td>
                                    <td><DeviceEventStatusBadge event={i}/></td>
                                    <td>{formatDateTime(i.date_created, edFormats.datetime_format)}</td>
                                    <td>{formatDateTime(i.date_updated, edFormats.datetime_format)}</td>
                                    <td ><Button size="sm" onClick={() => setCurrentEvent(i)}>Details</Button></td>
                                </tr>)}
                            </tbody>
                        </Table>
                        <EventDetailModal event={currentEvent} toggle={closeModal}></EventDetailModal>
                    </div>
                </Col>
            </Row>

            <PaginationRow totalCount={eventHistory?.count || 0} />
        </div>
    );
}


function EventDetailModal({ event, toggle }) {
    return (
        <div>
            <Modal isOpen={event.id} toggle={toggle} size="lg" >
                <ModalHeader className="bg-white py-3" toggle={toggle}>
                    <div className="py-3"></div>
                </ModalHeader>
                <ModalBody className="bg-white">
                    <DeviceEventDump event={event} />
                </ModalBody>
                <ModalFooter className="bg-white">
                    <Button color="secondary" onClick={toggle}>Close</Button>
                </ModalFooter>
            </Modal>
        </div>
    );
}

EventDetailModal.propTypes = {
    event: PropTypes.object,
    toggle: PropTypes.func
};
